import { render } from "./AddPostFeedCard.vue?vue&type=template&id=34d52325&scoped=true"
import script from "./AddPostFeedCard.vue?vue&type=script&lang=js"
export * from "./AddPostFeedCard.vue?vue&type=script&lang=js"

import "./AddPostFeedCard.vue?vue&type=style&index=0&id=34d52325&scoped=true&lang=css"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34d52325"]])

export default __exports__